module.exports = __webpack_public_path__ + "static/img/geotap-game-mobile-unlockable-low-poly-shapes.b4e69eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-game-mobile-unlockable-low-poly-shapes.jpg
// module id = D0cI
// module chunks = 0